import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Courses from "@/pages/Courses";
import CourseDetail from "@/pages/CourseDetail";
import FreeResources from "@/pages/FreeResources";
import ToolkitDetail from "@/pages/ToolkitDetail";
import AITools from "@/pages/AITools";
import AIToolDetail from "@/pages/AIToolDetail";
import Community from "@/pages/Community";
import Dashboard from "@/pages/Dashboard";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ProtectedRoute from "@/components/ProtectedRoute";
import Calculators from "@/pages/Calculators";
import Certificate from "@/pages/Certificate";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Toolbox from "@/pages/Toolbox";
import Coaching from "@/pages/Coaching";
import AskHostHustle from "@/pages/AskHostHustle";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/pages/AdminLayout";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payments";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/courses/:id" element={<CourseDetail />} />
            <Route path="/products" element={<Navigate to="/free-resources" replace />} />
            <Route path="/free-resources" element={<FreeResources />} />
            <Route path="/toolkits/:id" element={<ToolkitDetail />} />
            <Route path="/ai-tools" element={<AITools />} />
            <Route path="/ai-tools/:id" element={
              <ProtectedRoute><AIToolDetail /></ProtectedRoute>
            } />
            <Route path="/community" element={<Community />} />
            <Route path="/calculators" element={<Calculators />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/toolbox" element={<Toolbox />} />
            <Route path="/coaching" element={<Coaching />} />
            <Route path="/ask-coach" element={
              <ProtectedRoute><AskHostHustle /></ProtectedRoute>
            } />
            <Route path="/certificates/:courseId" element={
              <ProtectedRoute><Certificate /></ProtectedRoute>
            } />
            <Route path="/dashboard" element={
              <ProtectedRoute><Dashboard /></ProtectedRoute>
            } />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/*" element={<AdminLayout />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
